import { useState } from 'react';
import { Employee } from "../../model/Employee";
import { formatDate, formatDateSQL } from '../index2';
import { Eye, Edit3, Trash2, X, LoaderCircle } from 'lucide-react';
import Swal from 'sweetalert2';
import { cekTipeDataJson } from '..';

export let employees: Employee[] = [];

const updateEmployeesData = (updatedData = []) => {
  employees.length = 0; // Clear the existing array
  updatedData.forEach((item: any) => {
    employees.push({
      id: item.id || 'undefined',
      name: item.nama || 'Tidak ada Nama',
      nik: item.nik || 'Tidak ada NIK',
      status: item.status || 'Tidak ada Status',
      joinDate: item.tgl_masuk || 'Tidak ada Tanggal Gabung',
      contractYear: item.kontrak.tahun || '-',
      position: item.posisi || 'Tidak ada Informasi Posisi',
      contractDivisi: item.kontrak.divisi|| '-'
    });
  });
} 

export const getStatusBadge = (status: string) => {
    if (status === 'organic') {
        return (
            <span className="px-3 py-1 text-xs font-semibold bg-green-100 text-green-800 rounded-full">
                Karyawan Tetap
            </span>
        );
    }
    return (
      <span className="px-3 py-1 text-xs font-semibold bg-blue-100 text-blue-800 rounded-full">
        Kontrak
      </span>
    );
};

export const fetchGetKaryawanAll = async () =>{
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan");
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { 
      const dataKaryawan = result.data.map((el : any) => {
        return {
          ...el,
          rekening : cekTipeDataJson(el.rekening),
          pendidikan : cekTipeDataJson(el.pendidikan),
          resign :  cekTipeDataJson(el.pendidikan)
        }
      })
      console.log("Data Karyawan");
      console.log(dataKaryawan);
      updateEmployeesData(dataKaryawan ?? []); 
      return { "status" : result.status, "message" : result.message, data: employees }; 
    })
    .catch((error : any) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message , data: []} });
  
}

export const fetchPostKaryawan = async ({ karyawan } : { karyawan : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(karyawan),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan");
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchPutKaryawan = async ({ id , karyawan } : { id : string; karyawan : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(karyawan),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteKaryawan = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const RenderTableKaryawan = ({filteredData, onOpenDetail, onOpenEdit, onRemoveState} : { 
    filteredData: Employee[] | null; 
    onOpenDetail: (employee: Employee) => void;
    onOpenEdit: (employee: Employee) => void;
    onRemoveState: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = (karyawan: Employee) => {
    if (!karyawan || isLoading) return;

    Swal.fire({
      title: "Hapus Karyawan",
      text: `Apakah Anda yakin ingin menghapus karyawan ${karyawan.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2563EB",
      cancelButtonColor: "#6B7280",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal"
    }).then(async (result) => {
      if (result.isConfirmed) {
          try {
            setIsLoading(true);

            await fetchDeleteKaryawan(karyawan?.id); 
          } catch (error) {
            console.error("Error:", error);
          } finally {
            setIsLoading(false);
            
            Swal.fire({
              title: "Berhasil!",
              text: `Karyawan ${karyawan.name} berhasil dihapus.`,
              icon: "success"
            });
            
            onRemoveState();
          }
      }
    });
  }

  if (!filteredData?.length) {
    return (
      <tr>
        <td colSpan={18} className="text-center py-4 text-gray-500">
          Tidak ada data
        </td>
      </tr>
    );
  }

  return (
    <>
      {filteredData.map((karyawan) => (
        <tr key={karyawan.id} className="hover:bg-gray-50 transition-colors">
          <td className="px-6 py-4 whitespace-nowrap">
            {karyawan.name}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm">
            {karyawan.nik}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm">
            {karyawan.position}
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            {getStatusBadge(karyawan.status)}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm">
            {formatDate(karyawan.joinDate)}
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
            <div className="flex space-x-2">
              <button onClick={() => onOpenDetail(karyawan)} className="text-blue-600 hover:text-blue-900 p-1 rounded">
                <Eye className="w-4 h-4" />
              </button>

              <button onClick={() => onOpenEdit(karyawan)} className="text-green-600 hover:text-green-900 p-1 rounded">
                <Edit3 className="w-4 h-4" />
              </button>

              <button 
                onClick={() => handleDelete(karyawan)}
                className="text-red-600 hover:text-red-900 p-1 rounded">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </td>
        </tr>
      ))}
    </>
  );
}

export const DetailEmployeeModal = ({employeeDetail, stateShowModal} : { 
  employeeDetail: Employee | null,
  stateShowModal: (show: boolean) => void | false
}) =>(
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] flex flex-col">
      <div className="flex items-center justify-between p-4 border-b">
        <h3 className="text-xl font-semibold text-gray-800">
          Detail Karyawan
        </h3>

        <button
          onClick={() => stateShowModal(false)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          <X />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nama Lengkap
            </label>
            <label>
              {employeeDetail?.name}
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              NIK
            </label>
            <label>
              {employeeDetail?.nik}
            </label>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Posisi
            </label>
            <label>
              {employeeDetail?.position}
            </label>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Status Karyawan
            </label>
            {getStatusBadge(employeeDetail?.status.toString() || '')}
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Tanggal Masuk
            </label>
            <label>
              {employeeDetail?.joinDate ? formatDate(employeeDetail?.joinDate) : ''}
            </label>
          </div>
          
          {employeeDetail?.status === 'kontrak' && (
            <>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tahun Kontrak
                </label>
                <label>
                  {employeeDetail?.contractYear}
                </label>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Divisi Kontrak
                </label>
                <label>
                  {employeeDetail?.contractDivisi}
                </label>
              </div>
            </>
          )}
        </div>
      </div>   
    </div>
  </div>
);

export const AddEmployeeModal = ({setShowAddModal, onPostState} : {
    setShowAddModal: (show: boolean) => void | false; 
    onPostState: () => void 
}) => {
  const [formData, setFormData] = useState<Employee>({
    id: "",
    name: "",
    nik: "",
    status: "organic",
    joinDate: "",
    contractYear: 0,
    contractDivisi: "",
    position: "" // isi default kosong
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = useState(false);

  if (!formData) return null; // safety

  // fungsi validasi
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    const NIK_digit = 16;

    if (!formData.name.trim())
      newErrors.name = "Nama lengkap tidak boleh kosong.";

    if (formData.nik.length < NIK_digit)
      newErrors.nik = `NIK harus terdiri dari ${NIK_digit} digit angka.`;

    if (!formData.position)
      newErrors.position = "Posisi tidak boleh kosong.";

    if (!formData.status)
      newErrors.status = "Status karyawan tidak boleh kosong.";

    if (!formData.joinDate)
      newErrors.joinDate = "Tanggal masuk tidak boleh kosong.";

    if (formData.status === "kontrak" && (!formData.contractYear || formData.contractYear === 0))
      newErrors.contractYear = "Tahun kontrak tidak boleh kosong untuk karyawan kontrak.";

    if (formData.status === "kontrak" && (Number(formData.contractYear) < 1900 || Number(formData.contractYear) > 2100))
      newErrors.contractYear = "Tahun kontrak harus berada di antara 1900 dan 2100.";

    if (formData.status === "kontrak" && (!formData.contractDivisi || formData.contractDivisi === '-'))
      newErrors.contractDivisi = "Divisi kontrak tidak boleh kosong untuk karyawan kontrak.";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true kalau tidak ada error
  };

  const handleSubmit = async () => {
    if (!validateForm() || isLoading) return;

    try {
      setIsLoading(true);

      await fetchPostKaryawan({
        karyawan: formData
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);

      setShowAddModal(false);
      onPostState();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] flex flex-col">
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="text-xl font-semibold text-gray-800">
              Tambah Karyawan
            </h3>

            <button
              onClick={() => setShowAddModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X />
            </button>
          </div>
          
          <div className="flex-1 overflow-y-auto p-4">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nama Lengkap
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan nama lengkap karyawan"
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                />
                {errors.name && (
                  <p className="text-sm text-red-500 mt-1">{errors.name}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  NIK (Nomor Induk Kependudukan)
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan NIK karyawan"
                  value={formData.nik || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      nik: e.target.value,
                    })
                  }
                />
                {errors.nik && (
                  <p className="text-sm text-red-500 mt-1">{errors.nik}</p>
                )}
              </div>
            
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Posisi
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan posisi atau jabatan karyawan"
                  value={formData.position || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      position: e.target.value,
                    })
                  }
                />
                {errors.name && (
                  <p className="text-sm text-red-500 mt-1">{errors.position}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Status Karyawan
                </label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={formData?.status || "-"}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option value="-" disabled selected>Pilih Status</option>
                  <option value="organic">Karyawan Tetap</option>
                  <option value="kontrak">Kontrak</option>
                </select>
                {errors.status && (
                  <p className="text-sm text-red-500 mt-1">{errors.status}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tanggal Masuk
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={formatDateSQL(formData?.joinDate || '') ?? ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      joinDate: e.target.value,
                    })
                  }
                />
                {errors.joinDate && (
                  <p className="text-sm text-red-500 mt-1">{errors.joinDate}</p>
                )}
              </div>
              
              {formData.status === 'kontrak' && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tahun Kontrak
                    </label>
                    <input
                      type="number"
                      min="1900"
                      max="2100"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Masukkan tahun berakhir kontrak"
                      value={Number(formData?.contractYear) || Number(0)}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contractYear: Number(e.target.value),
                        })
                      }
                    />
                    {errors.contractYear && (
                      <p className="text-sm text-red-500 mt-1">
                        {errors.contractYear}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Divisi Kontrak
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Masukkan divisi kontrak"
                      value={formData?.contractDivisi || "-"}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contractDivisi: e.target.value,
                        })
                      }
                    />
                    {errors.contractDivisi && (
                      <p className="text-sm text-red-500 mt-1">{errors.contractDivisi}</p>
                    )}
                  </div>
                </>
              )}
            </div>

          </div>

          <div className="flex space-x-3 p-4 border-t">
            <button
              onClick={() => setShowAddModal(false)}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Batal
            </button>

            <button
              disabled={isLoading}
              onClick={handleSubmit}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
            >
              {isLoading && (
                <LoaderCircle className="w-4 h-4 animate-spin" />
              )}
              Simpan
            </button>
          </div>
        </div>
    </div>
  )
};

export const EditEmployeeModal = ({employeeDetail, stateShowModal, onEditState} : { 
  employeeDetail: Employee | null,
  stateShowModal: (show: boolean) => void | false,
  onEditState: () => void
}) => {
  const [formData, setFormData] = useState<Employee | null>(employeeDetail);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isLoading, setIsLoading] = useState(false);

  if (!formData) return null; // safety

  formData.contractYear = isNaN(Number(formData.contractYear)) ? 0 : Number(formData.contractYear);
  
  // fungsi validasi
  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    const NIK_digit = 16;

    if (!formData.name.trim())
      newErrors.name = "Nama lengkap tidak boleh kosong.";

    if (!formData.nik)
      newErrors.nik = "NIK tidak boleh kosong.";

    if (formData.nik.length < NIK_digit)
      newErrors.nik = `NIK harus terdiri dari ${NIK_digit} digit angka.`;

    if (!formData.position)
      newErrors.position = "Posisi tidak boleh kosong.";

    if (!formData.status)
      newErrors.status = "Status karyawan tidak boleh kosong.";

    if (!formData.joinDate)
      newErrors.joinDate = "Tanggal masuk tidak boleh kosong.";

    if (formData.status === "kontrak" && (!formData.contractYear || formData.contractYear === 0))
      newErrors.contractYear = "Tahun kontrak tidak boleh kosong untuk karyawan kontrak.";

    if (formData.status === "kontrak" && (Number(formData.contractYear) < 1900 || Number(formData.contractYear) > 2100))
      newErrors.contractYear = "Tahun kontrak harus berada di antara 1900 dan 2100.";

    if (formData.status === "kontrak" && (!formData.contractDivisi || formData.contractDivisi === '-'))
      newErrors.contractDivisi = "Divisi kontrak tidak boleh kosong untuk karyawan kontrak.";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true kalau tidak ada error
  };

  const handleSubmit = async () => {
    if (!validateForm() || isLoading) return;

    try {
      setIsLoading(true);

      await fetchPutKaryawan({
        id: formData.id, 
        karyawan: formData
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);

      stateShowModal(false); 
      onEditState();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] flex flex-col">
          <div className="flex items-center justify-between p-4 border-b">
            <h3 className="text-xl font-semibold text-gray-800">
              Edit Karyawan
            </h3>

            <button
              onClick={() => stateShowModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X />
            </button>
          </div>
          
          <div className="flex-1 overflow-y-auto p-4">
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nama Lengkap
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan nama lengkap karyawan"
                  value={formData.name || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      name: e.target.value,
                    })
                  }
                />
                {errors.name && (
                  <p className="text-sm text-red-500 mt-1">{errors.name}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  NIK (Nomor Induk Kependudukan)
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan NIK karyawan"
                  value={formData.nik || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      nik: e.target.value,
                    })
                  }
                />
                {errors.nik && (
                  <p className="text-sm text-red-500 mt-1">{errors.nik}</p>
                )}
              </div>
            
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Posisi
                </label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Masukkan posisi atau jabatan karyawan"
                  value={formData.position === "Tidak ada Informasi Posisi" ? "" : formData.position}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      position: e.target.value,
                    })
                  }
                />
                {errors.name && (
                  <p className="text-sm text-red-500 mt-1">{errors.position}</p>
                )}
              </div>
            
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Status Karyawan
                </label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={formData?.status || "-"}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option value="-" disabled selected>Pilih Status</option>
                  <option value="organic">Karyawan Tetap</option>
                  <option value="kontrak">Kontrak</option>
                </select>
                {errors.status && (
                  <p className="text-sm text-red-500 mt-1">{errors.status}</p>
                )}
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tanggal Masuk
                </label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={formatDateSQL(formData?.joinDate || '') ?? ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      joinDate: e.target.value,
                    })
                  }
                />
                {errors.joinDate && (
                  <p className="text-sm text-red-500 mt-1">{errors.joinDate}</p>
                )}
              </div>
              
              {formData.status === 'kontrak' && (
                <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Tahun Kontrak
                    </label>
                    <input
                      type="number"
                      min="1900"
                      max="2100"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Masukkan tahun berakhir kontrak"
                      value={Number(formData?.contractYear) || Number(0)}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contractYear: Number(e.target.value),
                        })
                      }
                    />
                    {errors.contractYear && (
                      <p className="text-sm text-red-500 mt-1">
                        {errors.contractYear}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Divisi Kontrak
                    </label>
                    <input
                      type="text"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Masukkan divisi kontrak"
                      value={formData?.contractDivisi || "-"}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contractDivisi: e.target.value,
                        })
                      }
                    />
                    {errors.contractDivisi && (
                      <p className="text-sm text-red-500 mt-1">{errors.contractDivisi}</p>
                    )}
                  </div>
                </>
              )}

            </div>
          </div>

          <div className="flex space-x-3 p-4 border-t">
            <button
              onClick={() => stateShowModal(false)}
              className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Batal
            </button>

            <button
              disabled={isLoading}
              onClick={handleSubmit}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
            >
              {isLoading && (
                <LoaderCircle className="w-4 h-4 animate-spin" />
              )}
              Simpan
            </button>
          </div>
        </div>
    </div>
  )
}
